module.exports = __webpack_public_path__ + "img/applicationPhone.103db891.png";